var exports = {
  "zr": "IncomingCallUI.module__root___OVJ0Mj",
  "Nr": "IncomingCallUI.module__card___OVJ0Mj",
  "BU": "IncomingCallUI.module__dragHandle___OVJ0Mj",
  "IH": "IncomingCallUI.module__dragPill___OVJ0Mj",
  "t$": "IncomingCallUI.module__stack___OVJ0Mj",
  "wx": "IncomingCallUI.module__header___OVJ0Mj",
  "nr": "IncomingCallUI.module__headerIcon___OVJ0Mj",
  "my": "IncomingCallUI.module__avatar___OVJ0Mj",
  "_0": "IncomingCallUI.module__ic-ring-pulse___OVJ0Mj",
  "sI": "IncomingCallUI.module__callerInfo___OVJ0Mj",
  "XF": "IncomingCallUI.module__callerName___OVJ0Mj",
  "_n": "IncomingCallUI.module__callerSubtitle___OVJ0Mj",
  "o1": "IncomingCallUI.module__actions___OVJ0Mj",
  "mH": "IncomingCallUI.module__actionGroup___OVJ0Mj",
  "T$": "IncomingCallUI.module__circleButton___OVJ0Mj",
  "FM": "IncomingCallUI.module__circleButtonAccept___OVJ0Mj",
  "cK": "IncomingCallUI.module__circleButtonReject___OVJ0Mj",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___OVJ0Mj",
  "ZJ": "IncomingCallUI.module__actionLabel___OVJ0Mj",
  "rw": "IncomingCallUI.module__ignoreLink___OVJ0Mj",
  "IR": "IncomingCallUI.module__screenReaderOnly___OVJ0Mj",
  "Po": "IncomingCallUI.module__bottomSheetStack___OVJ0Mj",
};

module.exports = exports;
